type TokenProvider = () => Promise<string>;

let provider: TokenProvider | null = null;
let lastKnown: string | null = null;

export const setTokenProvider = (fn: TokenProvider): void => {
  provider = fn;
};

export const resetTokenProvider = (): void => {
  provider = null;
  lastKnown = null;
};

export const getAccessToken = async (): Promise<string | null> => {
  if (!provider) return null;
  try {
    const token = await provider();
    lastKnown = token;
    return token;
  } catch (error) {
    console.warn('[Auth] Failed to obtain access token:', error);
    return null;
  }
};

export const getLastKnownAccessToken = (): string | null => lastKnown;

export const primeLastKnownAccessToken = (token: string | null): void => {
  lastKnown = token;
};
